import React from 'react'
import './../styles/AddImage.css'

function AddImage({ changeHandler, submitHandler, inputImageURL, sticky}) {
	return (
		<div className={`add-image ${sticky ? 'sticky' : null}`}>
			<form onSubmit={submitHandler}>
				<input
					type="text"
					value={inputImageURL}
					placeholder="Add Image With URL"
					onChange={changeHandler}
				/>
				<button>Add</button>
			</form>
		</div>
	)
}

// Date.now()

export default AddImage
